<template>
  <!-- <div class="card" style="max-height: 340px;"><img src="../assets/images/jexo-yVxUC9I9Cik-unsplash.jpg" class="img-fluid" alt="Responsive image"></div> -->
  <div class="card mt-5">
    <div class="row no-gutters">
      <div class="col-md-4">
        <img src="../assets/images/lg-mit-app-inventor-2.jpg"
             class="card-img"
             alt="...">
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <h1 class="card-title">App Inventor Code Analyzer</h1>
          <p class="card-text">App Inventor Analyzer is an automatic tool for assessing students' App Inventor projects.
            It generates a block frequency report of the uploaded projects in batch. It enables teachers to analyze App Inventor programs of the entire class .
          </p>
          <button type="button" class="btn btn-primary" @click="startRegister">Start Now!</button>
          <a href="/ai-analyzer/userguide.pdf" type="button" class="btn btn-info ml-4">User Guide</a>
          <!-- <p class="card-text"><small class="text-muted">go to code analyzer</small></p> -->
        </div>
      </div>
    </div>
  </div>`` 
</template>

<script>
export default {
    methods: {
      startRegister(){
        this.$router.push('/analyzer');
      }

    }
 
}
</script>